// removed by extract-text-webpack-plugin
module.exports = {"Collector":"Collector__Collector--3ReUQ","title":"Collector__title--2Nqqz","description":"Collector__description--300Of","MenuNavContainer":"Collector__MenuNavContainer--FfXii","MenuNavUl":"Collector__MenuNavUl--1vSAr","MenuNavLi":"Collector__MenuNavLi--1aMzQ","MenuNavBlock":"Collector__MenuNavBlock--hoc61","Patentinfo":"Collector__Patentinfo--3QEi5","CollectorImg":"Collector__CollectorImg--2SiB5","H2":"Collector__H2--7joEd","col-4":"Collector__col-4--1h5jj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Collector/Collector.css
// module id = 49
// module chunks = 0